export default "__VITE_ASSET__CX0O71Uc__"